// extracted by mini-css-extract-plugin
export default {"favicon":"favicon--RUcVV"};